var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.37533 0.333252H14.6253C16.0695 0.333252 17.2497 1.46363 17.3294 2.8879L17.3337 3.04159V10.9583C17.3337 12.4024 16.2032 13.5826 14.779 13.6623L14.6253 13.6666H3.37533C1.93113 13.6666 0.750951 12.5362 0.671276 11.1119L0.666992 10.9583V3.04159C0.666992 1.59739 1.79737 0.41721 3.22164 0.337535L3.37533 0.333252ZM16.0837 4.81075L9.29141 8.38634C9.13524 8.4685 8.95291 8.48025 8.78933 8.42159L8.70924 8.38634L1.91699 4.81158V10.9583C1.91699 11.7234 2.50625 12.3509 3.25572 12.4118L3.37533 12.4166H14.6253C15.3905 12.4166 16.018 11.8273 16.0788 11.0778L16.0837 10.9583V4.81075ZM14.6253 1.58325H3.37533C2.61018 1.58325 1.98267 2.17251 1.92183 2.92198L1.91699 3.04159V3.39909L9.00033 7.127L16.0837 3.39825V3.04159C16.0837 2.27644 15.4944 1.64893 14.7449 1.58809L14.6253 1.58325Z",
    fill: "url(#paint0_linear_107_1543)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_107_1543",
    x1: 0.666992,
    y1: 7.83325,
    x2: 17.3337,
    y2: 7.83325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF2E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.97b45575d8050b8b59ed346b14dac074.svg";
export { ForwardRef as ReactComponent };